import React, { Component } from "react";
import PropTypes from "prop-types";
import Paper from "material-ui/Paper";
import Toggle from "material-ui/Toggle";
import { Box } from "rebass";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { DivTitle } from "../../styled";
// import { BlockCounter } from "../";
import { SketchColorPicker, UploadImage } from "../../../../../components";

class BackgroundContent extends Component {
  constructor(props) {
    super(props);
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps,
      padding
    } = props;
    this.state = {
      backgroundColor: backgroundColor,
      backgroundImage: backgroundImage,
      isBackgroundImage: isBackgroundImage,
      bgProps: bgProps,
      padding: padding
    };
  }
  onUpdateUrl = value => {
    this.setState({ backgroundImage: value });
    const { backgroundColor, isBackgroundImage, bgProps, padding } = this.state;
    const values = {
      backgroundColor: backgroundColor,
      backgroundImage: value,
      isBackgroundImage: isBackgroundImage,
      bgProps: bgProps,
      padding: padding
    };
    this.props.updateBackground(values);
  };
  onToggle = (e, v) => {
    this.setState({ isBackgroundImage: v });
    const { backgroundColor, backgroundImage, bgProps, padding } = this.state;
    const values = {
      backgroundColor: backgroundColor,
      backgroundImage: backgroundImage,
      isBackgroundImage: v,
      bgProps: bgProps,
      padding: padding
    };
    this.props.updateBackground(values);
  };

  onChangeBackgroundImageProperties = (event, index, value, key) => {
    let {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps,
      padding
    } = this.state;
    bgProps[key] = value;
    this.setState({
      bgProps: bgProps
    });
    const values = {
      backgroundColor: backgroundColor,
      backgroundImage: backgroundImage,
      isBackgroundImage: isBackgroundImage,
      bgProps: bgProps,
      padding: padding
    };
    this.props.updateBackground(values);
  };
  onUpdateColor = color => {
    let { backgroundImage, isBackgroundImage, bgProps, padding } = this.state;
    this.setState({ backgroundColor: color });
    const values = {
      backgroundColor: color,
      backgroundImage: backgroundImage,
      isBackgroundImage: isBackgroundImage,
      bgProps: bgProps,
      padding: padding
    };
    this.props.updateBackground(values);
  };
  onUpdatePadding = padding => {
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps
    } = this.state;
    this.setState({ padding: padding });
    const values = {
      backgroundColor: backgroundColor,
      backgroundImage: backgroundImage,
      isBackgroundImage: isBackgroundImage,
      bgProps: bgProps,
      padding: padding
    };
    this.props.updateBackground(values);
  };
  render() {
    return (
      <Paper style={styles.paperText} zDepth={1}>
        <DivTitle>{this.props.title}</DivTitle>
        {/* <Box w={[1]} py={[1]}>
          Padding
        </Box>
        <BlockCounter
          containerPadding={this.state.padding}
          onUpdatePadding={containerPadding =>
            this.onUpdatePadding(containerPadding)
          }
        /> */}
        <SketchColorPicker
          title={"Background Color"}
          onUpdateColor={color => this.onUpdateColor(color)}
          color={this.state.backgroundColor}
        />
        <Box w={[1]} py={[1]}>
          <Toggle
            label="Using background image"
            style={{ marginBottom: 10 }}
            toggled={this.state.isBackgroundImage}
            onToggle={(e, v) => this.onToggle(e, v)}
          />
        </Box>
        {this.state.isBackgroundImage && (
          <div>
            <Box w={[1]} py={[1]}>
              <SelectField
                floatingLabelText="Size"
                onChange={(event, index, value) =>
                  this.onChangeBackgroundImageProperties(
                    event,
                    index,
                    value,
                    "size"
                  )
                }
                value={this.state.bgProps.size}
                autoWidth={true}
                name="background image size"
              >
                <MenuItem value={"contain"} primaryText="Contain" />
                <MenuItem value={"cover"} primaryText="Cover" />
              </SelectField>
            </Box>
            <Box w={[1]} py={[1]}>
              <SelectField
                floatingLabelText="Position"
                onChange={(event, index, value) =>
                  this.onChangeBackgroundImageProperties(
                    event,
                    index,
                    value,
                    "position"
                  )
                }
                value={this.state.bgProps.position}
                autoWidth={true}
                name="background image position"
              >
                <MenuItem value={"left"} primaryText="Left" />
                <MenuItem value={"center"} primaryText="Center" />
                <MenuItem value={"right"} primaryText="Right" />
              </SelectField>
            </Box>
            <Box w={[1]} py={[1]}>
              <SelectField
                floatingLabelText="Repeat"
                onChange={(event, index, value) =>
                  this.onChangeBackgroundImageProperties(
                    event,
                    index,
                    value,
                    "repeat"
                  )
                }
                value={this.state.bgProps.repeat}
                autoWidth={true}
                name="background image repeat"
              >
                <MenuItem value={"no-repeat"} primaryText="No Repeat" />
                <MenuItem value={"repeat"} primaryText="Repeat" />
              </SelectField>
            </Box>
            <Box w={[1]} py={[1]}>
              <SelectField
                floatingLabelText="Aspect ratio"
                onChange={(event, index, value) =>
                  this.onChangeBackgroundImageProperties(
                    event,
                    index,
                    value,
                    "ratio"
                  )
                }
                value={this.state.bgProps.ratio}
                autoWidth={true}
                name="background Aspect ratio"
              >
                <MenuItem value={1} primaryText="1" />
                <MenuItem value={1.2} primaryText="1.2" />
                <MenuItem value={1.4} primaryText="1.4" />
                <MenuItem value={1.5} primaryText="1.5" />
                <MenuItem value={1.7} primaryText="1.7" />
                <MenuItem value={1.8} primaryText="1.8" />
                <MenuItem value={2} primaryText="2" />
              </SelectField>
            </Box>
            <DivTitle>Background Image</DivTitle>
            <UploadImage
              type={"ease"}
              imageUrl={this.state.backgroundImage}
              onUpdateUrl={value => this.onUpdateUrl(value)}
              title="Image"
            />
          </div>
        )}
      </Paper>
    );
  }
}

BackgroundContent.propTypes = {
  updateBackground: PropTypes.func,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.object,
  bgProps: PropTypes.object,
  isBackgroundImage: PropTypes.bool,
  title: PropTypes.string
};

BackgroundContent.defaultProps = {
  title: "Background Row",
  backgroundImage: { url: "", urlMobile: "" },
  backgroundColor: "#FFFFFF",
  isBackgroundImage: false,
  bgProps: {
    size: "cover",
    position: "center",
    repeat: "no-repeat",
    ratio: 1.2
  },
  padding: "0px"
};

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  radioButton: {
    width: 100
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
    marginBottom: 10
  }
};

export default BackgroundContent;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/bgContent/index.js